export enum Pages {
  PROFILE = "/profile",
  PROJECTS = "/projects",
  EXPERIENCE = "/experience",
  COFFEE = "https://buymeacoffee.com/joeboylson",
}
